module.exports = __webpack_public_path__ + "img/20231221.b33d5749.jpeg";